import type { PaymentMethod } from '../../services/commonCheckout/types/PaymentMethod';

export const isManufacturerCardCheck = (
  paymentMethod: PaymentMethod<'CARD'>,
) => {
  return (
    paymentMethod.paymentMethodDetails.manufacturerCard ||
    paymentMethod.paymentMethodDetails.cardCategories?.[0]
      ?.type === 'MANUFACTURER_CARD'
  );
};
